module.exports = __webpack_public_path__ + "img/medal02.9469d244.svg";